import React from 'react'
import { Label, Input, AbsDropDown } from "abs-ui-components";
import * as _ from "lodash";


const FuelRegistryDropdown = ({

  label,
  name,
  bold = true,
  required = false,
  selected,
  handleChange,
  options,
  filterFn = (f) => f?.code && f?.name,
  mapFn = (f) => ({
    label: ["EU CSlip (Y/N)", "UK CSlip (Y/N)"].includes(label)
      ? f.name                          
      : `${f.fuelName} - ${f.code}`,    
    value: f.code
  }),
  sortBy = "label",
  includeSelectOption = true,
  style = {},
  className = "mb-1",
  colProps = { md: "3" },
  noGutters = true,
  ...dropdownProps

}) => {

  const processedOptions = _.chain(options)
    .filter(filterFn)
    .map(mapFn)
    .sortBy(sortBy)
    .thru((opts) =>
      includeSelectOption
        ? [{ label: "Select", value: "" }, ...opts]
        : opts
    )
    .value();

  return (
    <div className={noGutters ? "no-gutters" : ""} style={{ width: "100%" }}>
      <Label
        bold={bold}
        name={label}
        required={required}
        className={className}
      />
      <AbsDropDown
        name={name}
        handleChange={handleChange}
        selected={selected}
        options={processedOptions}
        {...dropdownProps}
      />
    </div>
  )
}

export default FuelRegistryDropdown
